import { toast } from "react-toastify";
import { trackPage } from "./analytics";

export function dataUrlFile(dataUrl, filename) {
  var arr = dataUrl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
};
export function generateNewNameImage() {
  return `${`${Math.floor(Math.random() * 99999999999999)}-${Math.floor(
    Math.random() * 99999999999999,
  )}-${Math.floor(Math.random() * 99999999999999)}`}.png`;
};

export const numberFormat = (value) =>
  new Intl.NumberFormat("en-IN").format(value);


 export function redirectToRocketDM(email, username) {
   fetch(`https://${process.env.REACT_APP_ROCKET_HOST}/api/v1/login`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        user: email,
        password: process.env.REACT_APP_ROCKET_PASS,
      }),
    })
      .then((r) => r.json())
      .then((res) => {
        const userId = res?.data?.userId;
        const token = res?.data?.authToken;
        // console.log(userId, token);
        window.open(
          `https://${process.env.REACT_APP_ROCKET_HOST}/direct/${username}?resumeToken=${token}&userId=${userId}`,
          "_blank"
        );
        trackPage('/synapse');
      })
      .catch((error) => {
        toast.error("An error ocurred");
        console.error(error);
      });
  }

  export function redirectToRocketChannel(email, rid) {
    fetch(`https://${process.env.REACT_APP_ROCKET_HOST}/api/v1/login`, {
       method: "POST",
       headers: {
         Accept: "application/json",
         "Content-Type": "application/json",
       },
       body: JSON.stringify({
         user: email,
         password: process.env.REACT_APP_ROCKET_PASS,
       }),
     })
       .then((r) => r.json())
       .then((res) => {
         const userId = res?.data?.userId;
         const token = res?.data?.authToken;
        //  console.log(userId, token);
         window.open(
           `https://${process.env.REACT_APP_ROCKET_HOST}/channel/${rid}?resumeToken=${token}&userId=${userId}`,
           "_blank"
         );
         trackPage('/synapse');
       })
       .catch((error) => {
         toast.error("An error ocurred");
         console.error(error);
       });
   }


   export function redirectToRocketPrivate(email, rid) {
    fetch(`https://${process.env.REACT_APP_ROCKET_HOST}/api/v1/login`, {
       method: "POST",
       headers: {
         Accept: "application/json",
         "Content-Type": "application/json",
       },
       body: JSON.stringify({
         user: email,
         password: process.env.REACT_APP_ROCKET_PASS,
       }),
     })
       .then((r) => r.json())
       .then((res) => {
         const userId = res?.data?.userId;
         const token = res?.data?.authToken;
         console.log(userId, token);
         window.open(
           `https://${process.env.REACT_APP_ROCKET_HOST}/group/${rid}?resumeToken=${token}&userId=${userId}`,
           "_blank"
         );
         trackPage('/synapse');
       })
       .catch((error) => {
         toast.error("An error ocurred");
         console.error(error);
       });
   }

  
  export function sendPushNotifications(externalsIds,title, message) {
    fetch(`https://onesignal.com/api/v1/notifications`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        'Authorization': `Basic ${process.env.REACT_APP_ONESIGNAL_REST_API_KEY}`
      },
      body: JSON.stringify({
        app_id: process.env.REACT_APP_ONESIGNAL_API_KEY,
        include_external_user_ids: externalsIds,
        headings:{
          en: title
        },
        contents:{
          en: message
        }
      }),
    })
      .then((r) => r.json())
      .then((res) => {
        console.log(res);
      })
      .catch((error) => {
        toast.error("An error ocurred");
        console.error(error);
      });
  }